import React, { useState } from "react";
import BaseListPortalView from "../overlay/BaseListPortalView";
import ManualListPlacementPage from "./ManualListPlacementPage";
import ActionButton from "../button/ActionButton";
import { OverlayOpacity } from "../portal/types";
import styles from "./ConnectionInviteOverlaySheet.module.css";
import happyFaceIcon from "../../assets/icons/purpleHappyFace.svg";
import { Connection } from "../../gql/types";

interface ConnectionInviteOverlaySheetProps {
    initialSelectedIds?: Set<string>;
    onBack: () => void;
    onConfirm: (selectedConnections: Connection[]) => void;
    baseZIndex?: number;
}

const ConnectionInviteOverlaySheet: React.FC<ConnectionInviteOverlaySheetProps> = ({
    initialSelectedIds,
    onBack,
    onConfirm,
    baseZIndex,
}) => {
    const [selectedIds, setSelectedIds] = useState<Set<string>>(initialSelectedIds ?? new Set());
    const [fetchedConnectionsMap, setFetchedConnectionsMap] = useState<Record<string, Connection>>({});

    const handleToggle = (connectionIds: string[]) => {
        setSelectedIds(prev => {
            const newSet = new Set(prev);
            connectionIds.forEach(id => {
                newSet.has(id) ? newSet.delete(id) : newSet.add(id);
            });
            return newSet;
        });
    };

    const handleFetchedConnectionsChange = (newConnections: Record<string, Connection>) => {
        setFetchedConnectionsMap(prev => ({ ...prev, ...newConnections }));
    };

    const handleConfirm = () => {
        const selectedConnections = Array.from(selectedIds)
            .map(id => fetchedConnectionsMap[id])
            .filter(Boolean);
        onConfirm(selectedConnections);
    };

    const header = (
        <div className={styles.headerContainer}>
            <div className={styles.iconContainer}>
                <img src={happyFaceIcon} className={styles.confirmationIcon} />
            </div>
            <div className={styles.title}>
                Please select connections to share your playdate invite.
            </div>
        </div>
    );

    const footer = (
        <div className={styles.footer}>
            <ActionButton
                onClick={handleConfirm}
                colorPattern="Default"
                className={styles.button}
            >
                Confirm
            </ActionButton>
        </div>
    );

    return (
        <BaseListPortalView
            onBack={onBack}
            header={header}
            footer={footer}
            baseZIndex={baseZIndex}
            overlayOpacity={OverlayOpacity.GRAY}
            sheetClassName={styles.sheet}
        >
            <div className={styles.connectionsContainer}>
                <ManualListPlacementPage
                    selectedIds={selectedIds}
                    onToggle={ids => handleToggle(ids)}
                    onFetchedConnectionsChange={handleFetchedConnectionsChange}
                />
            </div>
        </BaseListPortalView>
    );
};

export default ConnectionInviteOverlaySheet;